import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AbstractHttpService } from '../auth/http-abstract-service';
import { DownloadTrackerDto, EmailDataDto, EmailQueueDto, EmailQueueSearchDto, ResponseDto } from '../../dto';


@Injectable({
	providedIn: 'root'
})
export class HttpEmailService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/email');
	}

    saveEmail(input: EmailDataDto): Observable<ResponseDto> {
        return super.post(`/save`, input);
    }

	search(input: EmailQueueSearchDto): Observable<EmailQueueDto[]> {
		return super.post(`/get-all`, input);
	}

	getDownloads(emailQueueId: number): Observable<DownloadTrackerDto[]> {
		return super.get(`/${emailQueueId}/get-download-info`);
	}
}
